import http, { fetchApi } from "@/utils/axios";

// 科创活动网关前缀
const prefix = "/api/dscloud-activity";

// ---------- 活动管理 /kc/admin/activity ----------

// 活动分页查询（page 从 1 开始）
export const getTechActivityList = (params) => {
  return fetchApi(prefix + "/kc/admin/activity/list", params, "get", "params");
};

// 活动详情（查看 / 编辑回显）
export const getTechActivityDetail = (id) => {
  return fetchApi(prefix + "/kc/admin/activity/" + id, {}, "get", "params");
};

// 新增活动（新增后默认未发布）
export const addTechActivity = (data) => {
  return fetchApi(prefix + "/kc/admin/activity", data, "post", "data");
};

// 编辑活动（日程条目、核销人全量替换）
export const updateTechActivity = (data) => {
  return fetchApi(prefix + "/kc/admin/activity", data, "put", "data");
};

// 发布活动
export const publishTechActivity = (id) => {
  return fetchApi(prefix + "/kc/admin/activity/" + id + "/publish", {}, "put", "data");
};

// 取消发布活动
export const cancelPublishTechActivity = (id) => {
  return fetchApi(prefix + "/kc/admin/activity/" + id + "/cancel-publish", {}, "put", "data");
};

// ---------- 字典（板块、活动类型） ----------

// 板块列表
export const getSectionDict = () => {
  return fetchApi(prefix + "/kc/admin/section/list", { status: 1 }, "get", "params");
};

// 活动类型列表
export const getActivityTypeDict = () => {
  return fetchApi(prefix + "/kc/admin/activity-type/list", { status: 1 }, "get", "params");
};

// ---------- 报名审核 /kc/admin/registration ----------

// 审核分页查询（page 从 1 开始）
export const getAuditList = (params) => {
  return fetchApi(prefix + "/kc/admin/registration/audit/list", params, "get", "params");
};

// 审核页名额信息（选定活动后展示，实时计算不落库）
export const getAuditQuota = (activityId) => {
  return fetchApi(prefix + "/kc/admin/registration/audit/quota", { activityId }, "get", "params");
};

// 批量审核（双模式：ids 非空=手动勾选；ids 为空=全选模式，透传 4.1 筛选条件圈定全部待审核）
// operateStatus 1 通过 2 驳回（注意不是列表的 auditStatus）；响应 data = {successCount, failCount, failures:[{id,userName,reason}]}
export const auditSignUp = (data) => {
  return fetchApi(prefix + "/kc/admin/registration/audit", data, "put", "data");
};

// 审核二次确认预检（4.4，圈定入参与批量审核一致，operateStatus 可不传）
// 响应 data = [{activityId, activityName, capacity, occupied, remaining, selectedCount, exceededCount}]
export const auditPrecheck = (data) => {
  return fetchApi(prefix + "/kc/admin/registration/audit/confirm", data, "post", "data");
};

// 审核列表导出 Excel（4.4，Query 同 4.1 筛选条件，条件全空=全量；响应为文件流）
export const exportAuditList = (params) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/registration/audit/export",
    method: "get",
    params,
    responseType: "blob",
  });
};

// ---------- 报名列表 /kc/admin/registration ----------

// 报名分页查询（page 从 1 开始）
export const getRegistrationList = (params) => {
  return fetchApi(prefix + "/kc/admin/registration/list", params, "get", "params");
};

// 报名列表统计信息条（选定活动后展示；实时计算不落库，报名/取消/审核/核销后重拉刷新）
// data = { activityId, activityName, capacity 规模, registeredCount 已报名, checkedCount 已签到, uncheckedCount 未签到, signRate 签到率 }
export const getRegistrationQuota = (activityId) => {
  return fetchApi(prefix + "/kc/admin/registration/quota", { activityId }, "get", "params");
};

// 报名列表导出 Excel（5.4，Query 同 5.1 筛选条件，条件全空=全量；响应为文件流）
export const exportRegistrationList = (params) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/registration/export",
    method: "get",
    params,
    responseType: "blob",
  });
};

// ---------- 受邀记录管理 /kc/admin/invite（邀约记录 source=2，含未留手机号的无归属记录） ----------

// 受邀记录分页查询（page 从 1 开始）
export const getInviteRecords = (params) => {
  return fetchApi(prefix + "/kc/admin/invite/records", params, "get", "params");
};

// 受邀记录导出 Excel（Query 同分页筛选条件，条件全空=全量；响应为文件流）
export const exportInviteRecords = (params) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/invite/records/export",
    method: "get",
    params,
    responseType: "blob",
  });
};

// ---------- 展商企业管理 /kc/admin/exhibitor（管理端接口文档 v2 第 7 章） ----------
// 状态语义：1 上架 0 下架；上下架无独立接口，走 PUT 全量提交 status

// 展商企业分页查询（page 从 1 开始；返回字段同详情，含 content/sort/qrCodeContent/createTime）
export const getEnterpriseList = (params) => {
  return fetchApi(prefix + "/kc/admin/exhibitor/list", params, "get", "params");
};

// 展商企业详情
export const getEnterpriseDetail = (id) => {
  return fetchApi(prefix + "/kc/admin/exhibitor/" + id, {}, "get", "params");
};

// 新增展商企业（name ≤128 必填；logoUrl/introduction ≤512/content 富文本/sort/status 选填）
export const addEnterprise = (data) => {
  return fetchApi(prefix + "/kc/admin/exhibitor", data, "post", "data");
};

// 编辑展商企业（全量替换，另加 id；上下架同样走此接口改 status）
export const updateEnterprise = (data) => {
  return fetchApi(prefix + "/kc/admin/exhibitor", data, "put", "data");
};

// 删除展商企业
export const deleteEnterprise = (id) => {
  return fetchApi(prefix + "/kc/admin/exhibitor/" + id, {}, "delete", "params");
};

// 下载单个企业二维码（PNG 流，服务端文件名=企业名称.png）
export const downloadEnterpriseQr = (id) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/exhibitor/" + id + "/qr",
    method: "get",
    responseType: "blob",
  });
};

// 批量下载企业二维码（ZIP 流，Query 同列表筛选 name/status，服务端命名 企业二维码_日期.zip）
export const downloadEnterpriseQrBatch = (params) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/exhibitor/qr/batch",
    method: "get",
    params,
    responseType: "blob",
  });
};

// 合作意向分页查询（7.8，某企业的意向登记记录；page 从 1 开始）
// items: { id, exhibitorId, contactName 联系人, contactPhone 联系电话, cooperationDirection 合作方向, accountPhone 账号手机号, createTime 填写时间 }
export const getExhibitorIntentions = (id, params) => {
  return fetchApi(prefix + "/kc/admin/exhibitor/" + id + "/intentions", params, "get", "params");
};

// 导出合作意向 Excel（7.9，xlsx 文件流；服务端文件名=企业名称_合作意向.xlsx）
export const exportExhibitorIntentions = (id) => {
  return http({
    withCredentials: true,
    url: prefix + "/kc/admin/exhibitor/" + id + "/intentions/export",
    method: "get",
    responseType: "blob",
  });
};

// 取消报名（管理端不受限，支持批量）
export const cancelSignUp = (ids) => {
  return fetchApi(prefix + "/kc/admin/registration/cancel", { ids }, "put", "data");
};
